import { useGetCompanyCurrency } from "../../../../api/company";
import { getCompanyId } from "../../../../utils/cacheStorage";
import { DEFAULT_CURRENCY_CODE } from "../constants/versionDetails.constants";

/**
 * The current company's currency code for monetary display.
 *
 * Falls back to an empty code while loading or when the company has no currency set: a price
 * with no code is ambiguous, but a price with the *wrong* code is misleading, so we never guess.
 */
export function useCompanyCurrencyCode(): string {
  const companyId = getCompanyId();
  const { data } = useGetCompanyCurrency(companyId);

  return data?.alphabeticCode || DEFAULT_CURRENCY_CODE;
}
